import React from 'react';

import styles from './index.module.scss';

interface IProps {
  text: string;
  visible: boolean;
  onToggle: () => void;
}

const Index: React.FC<IProps> = (props) => {
  const { text, visible, onToggle } = props;
  if (visible) {
    return (
      <div className={styles.switcherWrapper} onClick={onToggle}>
        {text}
      </div>
    );
  }
  return null;
};

export default Index;
